import { Button, Flex, Select, Spinner } from "@chakra-ui/react";
import { usePagination } from "../contexts/PaginationContext";
import { useState } from "react";

interface Props {
  loading?: boolean;
  offset: number;
}
export function PaginationForm({ loading = false, offset }: Props) {
  const { limit, setLimit, options, setOffset } = usePagination();
  const [displayedLimit, setDisplayedLimit] = useState(limit);

  return (
    <Flex>
      <Button
        isDisabled={loading}
        onClick={() => {
          setLimit(displayedLimit);
          setOffset(offset);
        }}
      >
        Laad meer rijen {loading && <Spinner ml={2} size="xs" />}
      </Button>
      <Select
        data-testid="pagination-limit-select"
        ml={4}
        onChange={(e) => setDisplayedLimit(+e.target.value)}
        value={displayedLimit}
        w="fit-content"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option} rijen
          </option>
        ))}
      </Select>
    </Flex>
  );
}
